import * as React from "react";
import type { SVGProps } from "react";
const SvgThumbsDownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="thumbs_down_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M810.667 85.333H267.52a128 128 0 0 0-125.867 104.96L87.467 488.96A128 128 0 0 0 213.333 640h194.56L384 701.013a176.213 176.213 0 0 0 165.973 237.654 42.667 42.667 0 0 0 38.827-25.174L710.4 640h100.267a128 128 0 0 0 128-128V213.333a128 128 0 0 0-128-128zM640 588.373l-116.053 261.12a90.88 90.88 0 0 1-58.88-118.613l22.613-61.013a85.333 85.333 0 0 0-79.787-115.2h-194.56a42.667 42.667 0 0 1-32.853-15.36 42.667 42.667 0 0 1-9.813-34.987l54.186-298.667a42.667 42.667 0 0 1 42.667-34.986H640v417.706zM853.333 512a42.667 42.667 0 0 1-42.666 42.667h-85.334v-384h85.334a42.667 42.667 0 0 1 42.666 42.666V512z"
    />
  </svg>
);
export default SvgThumbsDownIcon;
